import { Card, CardContent, Chip, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { IComboBoxOption, IDispatchMaterialGroup, IMaterialGroup, IMaterialGroupInformationFormSection } from "../../interfaces";
import { Format, Sort, Values } from "../../utils";
import { AddFromInventoryDialog } from "../AddFromInventoryDialog";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { MaterialGroupTableRow } from "./MaterialGroupTableRow";

export const MaterialGroupInformationForm: React.FC<IMaterialGroupInformationFormSection> = ({
    entityId,
    status,
    materialGroups,
    onUpdateGroups,
    onUpdateGroup,
    expectedReturn,
    valueOnDispatch,
    readonly,
    saving,
    ...props
}: IMaterialGroupInformationFormSection) => {


    const [returnStatuses, setReturnStatuses] = useState<IComboBoxOption[]>([]);

    const getGroups = () => {
        //deep copy the object
        let clone = cloneDeep(materialGroups);

        //order materialGroups alphabetically
        Sort.materialGroups(clone);

        return clone;

    }

    const removeGroup = (materialGroup: IMaterialGroup) => {

        let model: IDispatchMaterialGroup[] = getGroups().filter(x =>
            x.id !== materialGroup.id
        );

        onUpdateGroups(model);
    }

    const totalValue = materialGroups?.reduce((acc, x) => acc + ((x.valueOnDispatch ?? 0) * x.requestedQuantity || 0), 0);

    useEffect(() => {
        if (returnStatuses.length === 0)
            Values.setValues("expectedmaterialreturnstates", setReturnStatuses);
    }, [materialGroups, returnStatuses.length])

    useEffect(() => {

    }, [expectedReturn])

    const MaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                {expectedReturn === true && <TableCell> Expected Return Condition</TableCell>}
                {valueOnDispatch === true && <TableCell>Sale Price (Each)</TableCell>}
                <TableCell />
            </TableRow>
        </TableHead>);
    }

    return (
        <Card>

            <FormSectionHeader label="Requested Materials" saving={saving} />

            <CardContent>
                <Grid container spacing={4}>
                    {materialGroups?.length > 0 ?
                        <>
                            {
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table>
                                            <MaterialTableHead />
                                            <TableBody>
                                                {getGroups().map((materialGroup, i) =>
                                                    <MaterialGroupTableRow
                                                        key={i}
                                                        dispatchMaterialGroup={materialGroup}
                                                        returnStatuses={returnStatuses}
                                                        onUpdate={onUpdateGroup}
                                                        expectedReturn={expectedReturn ?? false}
                                                        valueOnDispatch={valueOnDispatch ?? false}
                                                        readonly={readonly}
                                                        onRemove={() => removeGroup(materialGroup)}
                                                    />
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            }
                        </> :
                        <Grid item xs={12}>
                            <Typography
                                sx={{ pb: 2 }}
                                variant="subtitle2"
                            >
                                This dispatch request currently contains no materialGroups.
                            </Typography>
                        </Grid>
                    }
                </Grid>

                {!readonly &&
                    <Grid container>
                        <AddFromInventoryDialog
                            entityName="request"
                        />

                        {totalValue > 0 &&
                            <Chip
                                sx={{ ml: 1 }}
                                color="info"
                                label={"Total £" + Format.currency(totalValue)} />
                        }
                    </Grid>
                }
            </CardContent>
        </Card>
    );
}